/* eslint-disable @typescript-eslint/no-unused-vars */
import { Request, Response } from 'express';

import { Logger } from '@rover/rsdk/src/modules/Logging/ServerSideLogger';
import ObservabilityMetadata from '@rover/rsdk/src/modules/ObservabilityMetadata/ObservabilityMetadata';
import Profiler from '@rover/shared/js/ssr/Profiler';

import { GtmCookie } from './cookies/types';

export default {
  middleware: (): void => {},
  get: (key: string): unknown | undefined => undefined,
  set: (key: string, value: unknown): void => undefined,
  getGtmCookies: (): GtmCookie[] | undefined => undefined,
  getLogger: (): Logger | undefined => undefined,
  getMetrics: (): Profiler | undefined => undefined,
  getObservabilityMetadata: (): ObservabilityMetadata | undefined => undefined,
  getProfiler: (): Profiler | undefined => undefined,
  getProfilerKeys: (): Record<string, string> | undefined => undefined,
  getReq: (): Request | undefined => undefined,
  getRequestId: (): string | undefined => undefined,
  getRes: (): Response | undefined => undefined,
};
